function dataURLtoBlob(dataurl) {
  console.log(dataurl);
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);?/)[1],
    bstr = Buffer.from(arr[1], 'base64').toString('binary'),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

function downloadFile(url, name = 'file') {
  let a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', name);
  a.setAttribute('target', '_blank');
  a.click();
}

function downloadFileByBase64(base64, name) {
  let myBlob = dataURLtoBlob(base64);
  let myUrl = URL.createObjectURL(myBlob);
  downloadFile(myUrl, name);
}

export default downloadFileByBase64;
